import { pickBy } from 'lodash';

const cleanObjectFromEmptyValues = obj => pickBy(obj, val => !!val);

export default cleanObjectFromEmptyValues;
